import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PortalCheck = ({ portalPath, portalList = [], children }) => {
  const isPortalPath = portalList?.some((data) => data.path === portalPath);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isPortalPath) {
      navigate("/dashboard");
    }
  }, [isPortalPath, navigate]);
  if (!isPortalPath) {
    return null;
  }

  return <>{children}</>;
};

export default PortalCheck;
